import React, { Component } from 'react';
import { connect } from 'react-redux';
import update from 'immutability-helper';
import { bindActionCreators } from 'redux';
import uuidv4 from 'uuid';
import PropTypes from 'prop-types';

//components:
import NeuriteGrid from '../../components/neurite_grid';

//actions:
import { navigate, openDialog, hideDialog, setSaveState } from '../../actions';
import { getTiposZona, modifyTipoZona, removeTipoZona, addTipoZona, updateTiposZonaDB } from '../../actions/tipos_zona_actions';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

import * as config from '../../constants/configuration';

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    toolbar: {
        display: 'block',
        minHeight: '112px'
    },
    buttonsBottom: {
        marginRight: 15,
        padding: '10px 4%',
        marginBottom: 60,
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
        marginLeft: 8,
    },
    spinnerContainer: {
        width: '95%',
        height: 300,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    spinner: {
        width: '50px !important',
        height: '50px !important',
    },
});

class MaeAuxiliaresTipoZona extends Component {

    componentDidMount() {

        if (!this.props.user && config.AUTH) {
            this.props.navigate(""); //go to home page
            return;
        }

        this.props.getTiposZona();
    };

    messageDialog = (msg) => {

        this.props.openDialog('SimpleMessage', {
            message: msg
        }, uuidv4(), false, 'sm');
    };

    checkCvTipoZona = (tipoZona) => {
        if (this.props.tiposZona.find(c => (c.descr === tipoZona.descr) && (c.id !== tipoZona.id))) {
            this.messageDialog(`Ya existe una zona ${tipoZona.descr}`);
            return false;
        } else if (!tipoZona.descr.trim()) {
            this.messageDialog('Por favor, introduzca un Nombre');
            return false;
        } else if (isNaN(tipoZona.iKindElemImp)) {
            this.messageDialog('Por favor, introduzca un valor para el campo iKindElemImp');
            return false;
        }

        else return true;
    };

    newTipoZona = () => {
        this.props.openDialog('EditCvTipoZona', {
            cvTipoZona: {},
            okHandler: (tz) => {
                this.props.setSaveState(true);
                this.props.addTipoZona(tz);
            },
            checkTipoZona: this.checkCvTipoZona,
        }, uuidv4());
    };

    handleGridRowsUpdated = ({ fromRow, toRow, fromRowData, updated }) => {

        if (fromRow !== toRow) return; //solo modificamos una fila

        // for (let i = fromRow; i <= toRow; i++) {
        //     let updatedRow = update(this.props.tiposZona[i], { $merge: updated });
        //     this.props.setSaveState(true);
        //     this.props.modifyTipoZona(updatedRow);
        // }

        let updatedRow = update(this.props.tiposZona[fromRowData.grid_index], { $merge: updated });
        this.props.setSaveState(true);
        this.props.modifyTipoZona(updatedRow);

    };

    handleDeleteRow = tipoZona => {
        this.props.setSaveState(true);
        this.props.removeTipoZona(tipoZona);
    };

    // height = () => {
    //     if(this.props.tiposZona.length > 13) {
    //         return 500;
    //     }
    //     return (35 * (this.props.tiposZona.length + 1))
    // };

    render() {

        const { classes } = this.props;


        return (
            <div className={classes.root}>
                <div className={classes.toolbar} />
                <div style={{ marginBottom: 20 }}>
                    <NeuriteGrid
                        id="m_a_t_z"
                        columns={[
                            { key: 'descr', name: 'Descripción', editable: true, dragable: false, width: 140 },
                            // { key: 'iKindElemImp', name: 'KindElemImp', editable: true, dragable: false,}  //REVIEW
                        ]}
                        rows={this.props.tiposZona}
                        height={400}
                        buttonEdit={false}
                        buttonDelete={true}
                        buttonNew={true}
                        onNewRowClick={this.newTipoZona}
                        onRowsUpdated={this.handleGridRowsUpdated}
                        onDeleteClick={this.handleDeleteRow}
                        enableFilter={true}
                    />
                </div>

                <Button className={classes.buttonsBottom} variant="contained" color="primary" onClick={() => {
                    this.props.tiposZona.forEach(e => {
                        if (typeof e.id !== 'number') e.id = -1;
                    });

                    this.props.updateTiposZonaDB(this.props.tiposZona)
                }}>Guardar</Button>

            </div>

        );

    };

};

MaeAuxiliaresTipoZona.propTypes = {
    //state
    tiposZona: PropTypes.array.isRequired,
    user: PropTypes.object.isRequired,
    //dispatch
    navigate: PropTypes.func.isRequired,
    getTiposZona: PropTypes.func.isRequired,
    openDialog: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
    modifyTipoZona: PropTypes.func.isRequired,
    removeTipoZona: PropTypes.func.isRequired,
    addTipoZona: PropTypes.func.isRequired,
    updateTiposZonaDB: PropTypes.func.isRequired
};

function mapStateToProps(state) {

    return {
        user: state.oidc.user,
        tiposZona: state.tiposZona.tiposzona,
    };
};

function mapDispathToProps(dispatch) {
    return bindActionCreators({
        navigate,
        getTiposZona,
        openDialog,
        hideDialog,
        modifyTipoZona,
        removeTipoZona,
        addTipoZona,
        updateTiposZonaDB,
        setSaveState
    }, dispatch);
};

export default connect(
    mapStateToProps,
    mapDispathToProps
)(withStyles(styles, { withTheme: true })(MaeAuxiliaresTipoZona));

